import { assertUnreachableValue } from '#pplx/frontend/common/type_utils/unreachableValue.js';
export function isTypeaheadOverlayVisible({ variant, state, emptyMessage, }) {
    switch (state.status) {
        case 'idle':
        case 'error':
            return false;
        case 'done':
            return true;
        case 'loading':
            switch (variant) {
                case 'suggestDropdown':
                    // Suggestions have no useful pending content until rows arrive; keep the host frame closed too.
                    return state.rows.length > 0;
                case 'inline':
                case 'spotlight':
                case 'commandMenu':
                    return true;
                default:
                    return assertUnreachableValue(variant);
            }
        case 'empty': {
            const { providerSnapshots } = state;
            const hasSnapshots = providerSnapshots !== undefined && providerSnapshots.length > 0;
            return !(hasSnapshots
                ? providerSnapshots.every((snapshot) => snapshot.emptyMessage === null && snapshot.continuation === undefined)
                : emptyMessage === null);
        }
        default:
            return assertUnreachableValue(state);
    }
}
//# sourceMappingURL=overlayVisibility.js.map